export const APP_DEFINITION_ID = '12d5833e-f061-7cc8-5122-e1d404f6c8ae';

export const GOOGLE_ADS_GENERATOR_SCRIPT =
  'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
export const GOOGLE_ADS_META_PLATFORM_ACCOUNT_NAME =
  'google-adsense-platform-account';
export const GOOGLE_ADS_META_PLATFORM_ACCOUNT_CONTENT =
  'ca-host-pub-6654278186409559';
export const GOOGLE_ADS_META_PLATFORM_DOMAIN_NAME =
  'google-adsense-platform-domain';
export const GOOGLE_ADS_META_PLATFORM_DOMAIN_CONTENT = 'https://wix.com';
export const GOOGLE_ADS_META_PLATFORM_AUTHOR_URL_NAME =
  'google-adsense-platform-author-url';
export const GOOGLE_ADS_META_USER_ACCOUNT_NAME = 'google-adsense-account';
